// Updated AuthWrapper.jsx
import { motion } from "framer-motion";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const AuthWrapper = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="auth-loading">
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
          style={{
            width: 50,
            height: 50,
            borderRadius: "50%",
            border: "5px solid #4f46e5",
            borderTopColor: "transparent",
          }}
        />
      </div>
    );
  }

  if (user) return <Navigate to="/dashboard" replace />;

  return (
    <div className="auth-background">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        transition={{ duration: 0.5 }}
        className="auth-container-wrapper"
      >
        {children}
      </motion.div>
    </div>
  );
};

export default AuthWrapper;
